import TransferSubkonProduksiApi from "./TransferSubkonProduksiApi"

export default TransferSubkonProduksiApi